/*
 * @Author: your name
 * @Date: 2019-06-16 10:03:08
 * @LastEditTime : 2020-01-08 12:32:39
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\utility\tdtService\BusTransfer\Model\LinePlanItem.js
 */
import { SegmentItems } from "./SegmentItems";
import {GuidUtility} from "../../../common/GuidUtility.js";

export class LinePlanItem {

	constructor() {
		this.id=null;
		this.lineName = null;
		this.segments = new SegmentItems();

		this.lineNameDesc=null;
		//换乘次数
		this.transferTimes=0;

		this.crsCode="EPSG:4326";

		//选择状态
		this.selectedStatus=false;
	}

	getStartStation()
	{	
		let station=null;
		if(this.segments)
		{
			let firstSegment = this.segments.objects[0];
			station = firstSegment.stationStart;
		}

		return station;
	}

	getEndStation()
	{	
		let station=null;
		if(this.segments)
		{
			let endSegment = this.segments.objects[this.segments.objects.length-1];
			station = endSegment.stationEnd;
		}
		
		return station;
	}
	

	static GetLinePlanItem(jsonItemObj) {
		let planItem = null;
		if (jsonItemObj == null) return planItem;

		planItem = new LinePlanItem();
		planItem.id=GuidUtility.getGuid();
		planItem.lineName = jsonItemObj.lineName;
		planItem.lineNameDesc=planItem._getLineNameDesc();
		planItem.segments = SegmentItems.GetSegments(jsonItemObj.segments);
		if(planItem.segments)
		{	
			planItem.transferTimes=planItem.segments.getTransportCount()-1;
		}
		
		return planItem;
	}


	_getLineNameDesc()
	{	
		let nameDesc="";
		if(! this.lineName)return nameDesc;

		let replaceRegExp=new RegExp("\\|","g");
		
		nameDesc= this.lineName.replace(replaceRegExp,">");
		if(nameDesc.endsWith(">"))
		{
			nameDesc=nameDesc.substring(0,nameDesc.length-1).trim();
		}

		return nameDesc;
	}

}//end LinePlanItem

